import DSInput from "@/componentsDS/Input";
import { DEX_TYPE } from "@/config/constants";
import {
	validateDomain,
	validateEmail,
} from "@/utils/validate-email";
import validateMobile from "@/utils/validate-mobile";
import PropTypes from "prop-types";


const PersonalInfo = ({
	errors,
	register,
	countryCodes,
	personalInfo,
	setPersonalInfo,
	setValue,
}) => {
	return (
		<>
			<div className="login-box__section-title-buildex">
				Personal Information
			</div>
			<div className="login-box__form__cols--buildex">
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="firstName"
						label="First Name"
						placeholder="Enter name"
						errorMessage={errors.firstName?.message}
						required={true}
						id="first-name-input"
						fullWidth={true}
						register={register({
							required: "This field is mandatory",
						})}
						setValue={setValue}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="lastName"
						label="Last Name"
						placeholder="Enter name"
						errorMessage={errors.lastName?.message}
						required={true}
						id="last-name-input"
						fullWidth={true}
						register={register({
							required: "This field is mandatory",
						})}
						setValue={setValue}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half">
					<DSInput
						name="email"
						label="Company Email Address"
						placeholder="Enter company email"
						errorMessage={errors.email?.message}
						required={true}
						id="email-input"
						fullWidth={true}
						setValue={setValue}
						register={register({
							required: "This field is mandatory",
							validate: {
								checkEmail: (v) =>
									!v || validateEmail(v) ||
									"Please enter a valid company email address",
								checkDomain: (v) =>
									!v || validateDomain(v, DEX_TYPE.SGBUILDEX) ||
									"The following domain are not allowed to be registered",
							},
						})}
					/>
				</div>
				<div className="login-box__form__col login-box__form__col--half login-box-buildex__dropdown">
					<DSInput
						name="mobileNo"
						label="Mobile Number"
						placeholder="Enter number"
						errorMessage={errors.mobileNo?.message}
						required={false}
						id="mobile-no-input"
						type="number"
						fullWidth={true}
						setValue={setValue}
						register={register({
							required: false,
							minLength: {
								value: 6,
								message:
									"Please enter valid mobile number ranging between 6-15 digits",
							},
							maxLength: {
								value: 15,
								message:
									"Please enter valid mobile number ranging between 6-15 digits",
							},
							validate: {
								checkMobileNumber: (v) =>
									validateMobile(v) ||
									"Please enter a valid number",
							},
						})}
						prefixDropdown={true}
						prefixDropdownOption={countryCodes}
						prefixDropdownSelectedOption={[
							{ id: personalInfo.mobileCountryCode?.id },
						]}
						prefixDropdownOnAdd={(item) =>
							setPersonalInfo((prev) => ({
								...prev,
								mobileCountryCode: item[0],
							}))
						}
						prefixDropdownValue={personalInfo.mobileCountryCode?.cc}
					/>
				</div>
			</div>
		</>
	);
};

export default PersonalInfo

PersonalInfo.propTypes = {
	errors: PropTypes.objectOf(
		PropTypes.shape({
			message: PropTypes.string,
		})
	).isRequired,
	register: PropTypes.func.isRequired,
	countryCodes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			cc: PropTypes.string,
			name: PropTypes.string,
		})
	).isRequired,
	personalInfo: PropTypes.shape({
		mobileCountryCode: PropTypes.shape({
		id: PropTypes.string.isRequired,
		label: PropTypes.string.isRequired,
		cc: PropTypes.string.isRequired,
		}).isRequired,
	}).isRequired,
	setPersonalInfo: PropTypes.func.isRequired,
	setValue: PropTypes.func.isRequired,
}
